module.exports = __webpack_public_path__ + "assets/linea1.9ba4665f946773563b2ab6e05398d292.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/linea1.png
 ** module id = 853
 ** module chunks = 0
 **/